import {dateField, EntityData, field, identifier} from "@fedeltapointofsale/data-client";

export class ContactSearchData extends EntityData<ContactSearchData> {
    @identifier id: string;
    @field integratedLoyaltyId: string;
    @field firstName: string;
    @field lastName: string;
    @field email: string;
    @field mobilePhone: string;
    @dateField dob: Date;
}
